import React from 'react';
import { DetailsForm } from '@sma/components/meteringProfile';
import meteringProfileShape from '@sma/components/meteringProfile/shape';

const Details = ({ meteringProfile }) => (
  <div className="metering-profile-details-pane">
    <DetailsForm meteringProfile={meteringProfile} />
  </div>
);

Details.propTypes = {
  meteringProfile: meteringProfileShape.isRequired,
};

export default Details;
